import { useContext } from 'react';
import { Link } from 'react-router';
import { AuthContext } from '../context/AuthContext';
import { formatDateToYYYYMMDD } from '../lib/dateHelper';

const MembershipBanner = () => {
    const { auth } = useContext(AuthContext);

    // Determine if we should show the banner and what color it should be
    const getBannerInfo = () => {
        if (!auth?.user?.membershipExpiration) return { show: false };
        
        const expirationDate = new Date(auth?.user?.membershipExpiration);
        const currentDate = new Date();
        const oneMonthBeforeExpiration = new Date(expirationDate);
        oneMonthBeforeExpiration.setMonth(oneMonthBeforeExpiration.getMonth() - 1);
        
        if (currentDate > expirationDate) {
            return { show: true, color: 'bg-red-200 border border-red-300' }; // Expired
        } else if (currentDate > oneMonthBeforeExpiration) {
            return { show: true, color: 'bg-yellow-200 border border-yellow-300' }; // Less than a month before expiration
        } else {
            return { show: false }; // More than a month before expiration - hide banner
        }
    };

    const bannerInfo = getBannerInfo();
    
    // If we shouldn't show the banner, return null
    if (!bannerInfo.show) return null;

    return (
        <div className='w-full pt-1 flex justify-center items-center'>
            <div className={`w-5/6 flex rounded-md ${bannerInfo.color} p-2`}>
                <div className='w-full py-1 px-3 text-sm grid grid-cols-3 text-center'>
                    <div className='col-span-3'>
                        {bannerInfo.color === 'bg-red-200 border border-red-300' 
                            ? <>Ditt medlemskap gick ut {formatDateToYYYYMMDD(auth.user.membershipExpiration)}. Kontakta <Link className='text-blue-600 hover:underline' to={`/clubs/${auth.user.memberOfClub}`}>din förening</Link> för att förnya så du kan tävla på nytt.</> 
                            : <>Ditt medlemskap går ut {formatDateToYYYYMMDD(auth.user.membershipExpiration)}. Kontakta <Link className='text-blue-600 hover:underline' to={`/clubs/${auth.user.memberOfClub}`}>din förening</Link> för att förnya det innan dess, så att du kan fortsätta tävla.</>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MembershipBanner;